/**
 * Created by Viacheslav Stepanian on 26.02.2026.
 */

const ProgressQuestRow = function (row) {
    return Prefab.instantiate(bundles.quests_window.jsons.progress_quest_row_prefab_json, { row });
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PROGRESSQUESTROW_TITLE: {
        name: "nostroke",
        color: new cc.Color(168, 66, 38),
        size: 50
    },
    PROGRESSQUESTROW_PROGRESS: {
        name: "nostroke",
        color: new cc.Color(168, 66, 38),
        size: 28
    }
});